































































































































































































































































































































































































import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";

import Vue from "vue";
import {
  ApiSearchColumn,
  ColumnType,
} from "@/components/apiSearch/models/ApiSearch";
import { FilteringModel } from "@/services/filtering";
import CashInView from "@/modules/cashStatement/CashInView/models/CashInView";
import CheckBox from "@/components/CheckBox.vue";
import cashStatementStore, {
  CashStatementStore,
} from "@/modules/cashStatement/services/store";
import eventBus from "@/services/eventBus";
import cashDocByReceiptsStore, {
  CashDocByReceiptsStore,
} from "../../receipt/services/CashDocByreceiptsStore";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import pStore, {
  PaymentModeStore,
} from "@/modules/paymentMode/services/PaymentModeStore";
import ValidationError from "@/modules/downPayment/components/ValidationError.vue";
import MoneyInput from "@/components/MoneyInput.vue";
import PartnerSearch from "@/modules/partner/views/PartnerSearch.vue";
import Partner from "@/modules/partner/models/Partner";
import DateInput from "@/components/DateInput.vue";
import configuration from "@/models/Configuration";
import dayjs from "dayjs";
import InterfaceApi from "@/modules/interface/services/InterfaceApi";
import { Iface } from "@/modules/interface/models/Iface";
import { IfaceType } from "@/modules/interface/models/IfaceType";
import { t } from "@/plugins/i18n";

interface Data {
  filter: FilteringModel;
  sum: number;
  items: CashInView[];
  selectedItems: CashInView[];
  cashDocByReceiptsStore: CashDocByReceiptsStore;
  cashStatementStore: CashStatementStore;
  pStore: PaymentModeStore;
  addAll: boolean;
  selectedPartner: number;
  incadeaSyncAvailable: boolean;
}

interface Props {
  extraFilter: FilteringModel;
  partnerId: number;
  currency: string;
  cashDocByReceipts: boolean;
  isCreditCardPay: boolean;
  title: string;
  inStatement: boolean;
  invPrefix: string;
  invNo: number;
  isFullPage: boolean;
  noPadding: boolean;
  noActionsColor: boolean;
  showPartnerSearch: boolean;
}

interface Computed {
  columns: ApiSearchColumn[];
  url: string;
  okButtonName: string;
  sumAmount: number;
}

interface Methods {
  selected(item: CashInView): void;
  showDetails(item: CashInView): void;
  addToSummary(dataItem: CashInView): void;
  setItems(items: CashInView[]): void;
  addItems(): void;
  amountChanged(): void;
  selectAllItems(): void;
  refresh(): void;
  partnerSelected(partner: Partner): void;
  paymAmountRange(item: CashInView): { min: number; max?: number };
  sameInvoice(a: CashInView, b: CashInView): boolean;
  syncInvoicesFromInterface(): void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    ApiSearchPage,
    CheckBox,
    MoneyDisplay,
    ValidationError,
    MoneyInput,
    PartnerSearch,
    DateInput
  },

  props: {
    extraFilter: { type: Object as () => FilteringModel },
    partnerId: { type: Number, default: 1 },
    currency: { type: String, default: "" },
    cashDocByReceipts: { type: Boolean, default: false },
    title: {
      type: String,
      default: t("Szamlavalogato"),
    },
    isCreditCardPay: { type: Boolean, default: false },
    inStatement: {type: Boolean, default: false},
    invPrefix: { type: String, default: "" },
    invNo: { type: Number, default: 1 },
    isFullPage: {type: Boolean, default: false},
    noPadding: {type: Boolean, default: false},
    noActionsColor: {type: Boolean, default: false},
    showPartnerSearch: {type: Boolean, default: false},
  },

  data: () => ({
    filter: new FilteringModel(),
    sum: 0,
    items: [],
    selectedItems: [],
    cashDocByReceiptsStore,
    cashStatementStore,
    pStore,
    addAll: false,
    selectedPartner: 1,
    incadeaSyncAvailable: false,
  }),

  async beforeMount() {
    this.cashDocByReceiptsStore.isCreditCardPay=this.isCreditCardPay;
    if (this.pStore.paymentModes.length < 2) {
      await this.pStore.loadPaymentModesWithoutBusy();
    }

    if (this.$props.extraFilter)
      this.filter = this.filter.fromFilter(this.$props.extraFilter.toObject());

    this.selectedPartner = this.$props.partnerId;

    // A szinkron gomb csak a teljes oldalas nézetben látszik, és csak akkor aktív,
    // ha az Incadea interfész él (cssysisynciface: live_dead).
    // if (this.isFullPage) {
      const interfaces = await InterfaceApi.getLiveInterfaces();
      this.incadeaSyncAvailable = interfaces.some((i) => i.id === Iface.Incadea);
    // }
  },

  methods: {
    /**
     * Számlák szinkronizálása az Incadea interfészről. A szinkron hívás és az azt követő
     * lista frissítés egyetlen busy indicator alatt fut.
     */
    async syncInvoicesFromInterface() {
      try {
        eventBus.$emit("busy-message", true);

        await InterfaceApi.downSync(
          dayjs().startOf("day").toDate(),
          new Date(),
          Iface.Incadea,
          IfaceType.None
        );

        this.refresh();
      } catch (ex) {
        console.log(ex);
      } finally {
        eventBus.$emit("busy-message", false);
      }
    },

    // OVERPAYM_CARD syskapcsolóval a nyitott résznél nagyobb összeg (túlfizetés) is megadható
    paymAmountRange(item: CashInView) {
      return this.$props.isFullPage && configuration.sysParams.overPaymCard
        ? { min: 0 }
        : { min: 0, max: item.toPayment };
    },

    partnerSelected(partner: Partner){
      this.refresh();
    },

    // Két sor akkor ugyanaz a számla, ha a prefix ÉS a sorszám is egyezik:
    // az invNo prefixenként külön sorszámozás (v_cashin UNION ALL), önmagában
    // nem egyedi. (MIKT40: a korábbi, nem létező "code" mezőre kulcsolt
    // összehasonlítás undefined === undefined miatt csak az invNo-t nézte, így
    // más prefixű számla örökölte a kijelölést és a fizetendő összeget.)
    sameInvoice(a: CashInView, b: CashInView) {
      return a.invNo === b.invNo && a.prefix === b.prefix;
    },

    refresh(){
      const childComponentInstance = this.$refs.asref;
      if (childComponentInstance) {
        (this.$refs.asref as any).refreshClick();
      }
    },
    
    selectAllItems(){
      // Csak az aktuális oldal sorait jelöli ki/veszi le, a más oldalakon
      // korábban kiválasztott számlák megmaradnak.
      this.addAll = !this.addAll;

      if (this.addAll) {
        this.items.forEach(x => {
          if (x.lockAction.length == 0 && !x.added) {
            this.addToSummary(x);
          }
        });
      } else {
        this.items.forEach(x => {
          if (x.added) {
            this.addToSummary(x);
          }
        });
      }

      this.amountChanged();
    },

    async addItems() {
      try {
        this.$emit("add-selected-items", [...this.selectedItems]);
        this.selectedItems = [];
      } catch (ex) {
        console.log(ex);
        this.sum = 0;
        eventBus.$emit("cash-in-view:get-items");
        setTimeout(() => {
          this.items = this.items.map((x) => {
            return { ...x, added: false };
          });
          eventBus.$emit("cash-in-view:set-items", this.items);
          this.selectedItems = [];
        }, 100);
      }
    },

    selected(item: CashInView) {
      this.$emit("selected", item);
    },

    showDetails(item: CashInView) {
      item.selected = !item.selected;
    },

    addToSummary(dataItem: CashInView) {
      // A selectedItems-et azonnal, közvetlenül karbantartjuk: a korábbi
      // get-items eventbus kör csak a KÖVETKEZŐ eseménynél vette fel a most
      // kijelölt számlát, így lapozáskor/szűréskor az utolsó kijelölés elveszett.
      if (!dataItem.added) {
        dataItem.added = true;
        const alreadySelected = this.selectedItems.some((x) =>
          this.sameInvoice(x, dataItem)
        );
        if (!alreadySelected) {
          this.selectedItems.push(dataItem);
        }
      } else {
        dataItem.added = false;
        this.selectedItems = this.selectedItems.filter(
          (x) => !this.sameInvoice(x, dataItem)
        );
      }
      this.amountChanged();
    },

    amountChanged(){
      this.sum = 0;
      this.selectedItems.forEach(x => this.sum += x.paymAmount);
      this.$emit("update-sum", this.sum);
    },

    setItems(items) {
      this.items = items;
      const newSelected = items.filter((x) => x.added);
      newSelected.forEach((element) => {
        // Stabil üzleti kulcs (prefix + invNo) szerint dedupolunk, nem objektum-
        // referencia szerint: minden lekérdezés (lapozás/szűrés/rendezés) új
        // objektumokat ad vissza, így a referencia-egyezés nem ismerné fel az
        // ugyanazt a számlát, és duplikátumként kerülne a kiválasztottak közé.
        const alreadySelected = this.selectedItems.some((x) =>
          this.sameInvoice(x, element)
        );
        if (!alreadySelected) {
          this.selectedItems.push(element);
        }
      });

      // Lapozás/szűrés után a frissen letöltött sorokon visszajelöljük a
      // korábban kiválasztott számlákat, és a selectedItems-ben a régi
      // objektumot a megjelenített frissre cseréljük; a felhasználó által
      // szerkesztett mezőket (fizetendő összeg, kiegyenlítés napja,
      // végszámla megjegyzés) átvisszük a friss sorra.
      this.selectedItems = this.selectedItems.map((sel) => {
        const fresh = items.find((x) => this.sameInvoice(x, sel));
        if (fresh && fresh !== sel) {
          fresh.added = true;
          // A korábban kézzel írt összeget csak akkor vesszük át, ha a sorra
          // megengedett tartományba esik (OVERPAYM_CARD nélkül legfeljebb a
          // frissen lekérdezett nyitott rész) - különben a szerver értékét hagyjuk.
          const range = this.paymAmountRange(fresh);
          fresh.paymAmount =
            sel.paymAmount > 0 &&
            (range.max === undefined || sel.paymAmount <= range.max)
              ? sel.paymAmount
              : fresh.toPayment;
          fresh.selectedShipDate = sel.selectedShipDate;
          fresh.finalRemark = sel.finalRemark;
          return fresh;
        }
        return sel;
      });

      const selectable = items.filter((x) => x.lockAction.length == 0);
      this.addAll =
        selectable.length > 0 && selectable.every((x) => x.added);

      this.amountChanged();
    },
  },

  computed: {
    sumAmount() {
      return this.sum;
    },

    okButtonName() {
      return this.cashDocByReceiptsStore.isCreditCardPay
        ? t("Fizetes")
        : t("Letrehozas");
    },

    columns: function() {
      const ret = this.$props.cashDocByReceipts
        ? [
            {
              cell: "detailsButton",
              filterable: false,
              header: 'allSelect'
            },
            //{ field: "prefix", title: "Prefix", headerClass: "prefix-column" },
            { field: "maskedInvNo", title: t("Szamlaszam"), cell: "invNo" },
            { field: "partner", title: t("Partner") },
            {
              field: "pmode",
              title: t("FizetesiMod"),
              width: 170,
              multiselect: true,
              multiselectField: "pmodes",
              multiselectOptions: this.pStore.paymentModes.map((x) => ({
                text: x.name,
                value: x.id,
              })),
              multiselectSelect: /*this.$props.isCreditCardPay
                ? this.pStore.paymentModes
                    .filter((x) => x.name === "Bankkártya")
                    .map((x) => x.id)[0]
                : */this.pStore.paymentModes
                    .filter((x) => x.name === "Készpénz" || x.name === "Bankkártya")
                    .map((x) => x.id),
            },
            // { field: "pmode", title: "Fizetési mód" },
            {
              cell: "currNetto",
              field: "currNetto",
              title: t("CashStatement_NettoASzamlaPenznemeben"),
              type: ColumnType.Money,
            },
            {
              cell: "currTotal",
              field: "currTotal",
              title: t("CashStatement_BruttoASzamlaPenznemeben"),
              type: ColumnType.Money,
            },
            {
              cell: "exchangeRate",
              field: "exchangeRate",
              width: 150,
              visible: this.$props.currency != "HUF",
              title: t("CashStatement_SzamlanSzereploArfolyam"),
              type: ColumnType.Money,
            },
            {
              cell: "netto",
              field: "netto",
              visible: this.$props.currency != "HUF",
              title: t("CashStatement_NettoAPenztarPenznemeben"),
              type: ColumnType.Money,
            },
            {
              cell: "total",
              field: "total",
              visible: this.$props.currency != "HUF",
              title: t("CashStatement_BruttoAPenztarPenznemeben"),
              type: ColumnType.Money,
            },
            {
              cell: "toPayment",
              field: "toPayment",
              title: t("SzlaNyitottResz"),
              type: ColumnType.Money,
              filterable: false, 
              sortable: false
            },
            { field: "remark", title: t("Megjegyzes"), fieldClass: "note-column" },
            { field: "finalRemark", title: t("VegszamlaMegjegyzes"), cell: 'finalRemark', filterable: false, sortable: false },
          ]
        : [
            {
              cell: "detailsButton",
              filterable: false,
              header: 'allSelect'
            },
            //{ field: "prefix", title: "Prefix", headerClass: "prefix-column" },
            { field: "maskedInvNo", title: t("Szamlaszam"), cell: "invNo" },
            { field: "partner", title: t("Partner") },
            {
              field: "pmode",
              title: t("FizetesiMod"),
              multiselect: true,
              multiselectField: "pmodes",
              multiselectOptions: this.pStore.paymentModes.map((x) => ({
                text: x.name,
                value: x.id,
              })),
            },
            // { field: "pmode", title: "Fizetési mód" },
            {
              cell: "currNetto",
              field: "currNetto",
              title: t("CashStatement_NettoASzamlaPenznemeben"),
              type: ColumnType.Money,
            },
            {
              cell: "currTotal",
              field: "currTotal",
              title: t("CashStatement_BruttoASzamlaPenznemeben"),
              type: ColumnType.Money,
            },
            {
              cell: "exchangeRate",
              field: "exchangeRate",
              width: 150,
              visible: this.$props.currency != "HUF",
              title: t("CashStatement_SzamlanSzereploArfolyam"),
              type: ColumnType.Money,
            },
            {
              cell: "netto",
              field: "netto",
              visible: this.$props.currency != "HUF",
              title: t("CashStatement_NettoAPenztarPenznemeben"),
              type: ColumnType.Money,
            },
            {
              cell: "total",
              field: "total",
              visible: this.$props.currency != "HUF",
              title: t("CashStatement_BruttoAPenztarPenznemeben"),
              type: ColumnType.Money,
            },
            {
              cell: "toPayment",
              field: "toPayment",
              title: t("SzlaNyitottResz"),
              type: ColumnType.Money,
              filterable: false,
              sortable: false
            },
            { field: "remark", title: t("Megjegyzes"), fieldClass:"note-column" },
            { field: "finalRemark", title: t("VegszamlaMegjegyzes"), cell: 'finalRemark', filterable: false, sortable: false },
          ];

          if (this.$props.isCreditCardPay){
            ret.splice(2, 0, {
              field: "outerInvNo",
              title: t("KulsoSzamlaszam"),
            });

            ret.splice(7, 0, {
              cell: "paymAmountRight",
              field: "",
              title: t("Fizetendo"),
              type: ColumnType.Money,
              filterable: false, 
              sortable: false
            });

            ret.splice(7, 0, {
              cell: "selectedShipDate",
              field: "",
              title: t("CashStatement_KiegyenlitesNapja"),
              filterable: false, 
              sortable: false,
            });

            ret[7].width = 250;
          }

          return ret;
    },

    url() {
      if(this.$props.cashDocByReceipts && this.$props.isCreditCardPay && !this.$props.currency){
        if (this.$props.invPrefix && this.$props.invNo > 1){
          return `cash-flow/in/dto/search/cashdocbyreceipts/credit-card/${this.$props.invPrefix}/${this.$props.invNo}`
        }

        return `cash-flow/in/dto/search/cashdocbyreceipts/credit-card`
      }

      return this.$props.cashDocByReceipts
        ? this.$props.isCreditCardPay
          ? `cash-flow/in/dto/search/cashdocbyreceipts/${
              this.$props.currency
            }/${true}`
          : `cash-flow/in/dto/search/cashdocbyreceipts/${
              this.$props.currency
            }/${false}`
        : `cash-flow/in/dto/search/${this.selectedPartner}/${this.$props.currency}`;
    },
  },
});
